module.exports = __webpack_public_path__ + "static/media/connection-3.cdf463d0.svg";